import { render, staticRenderFns } from "./MultipleNameInputs.vue?vue&type=template&id=f0fa73b8&lang=pug"
import script from "./MultipleNameInputs.vue?vue&type=script&lang=js"
export * from "./MultipleNameInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports